import gymSwimmingPool from '@/assets/img/users-cases/gym-swimming-pool.webp';
import gymSwimmingPoolHow from '@/assets/img/users-cases/gym-swimming-pool-how.webp';
import gymSwimmingPoolResult from '@/assets/img/users-cases/gym-swimming-pool-result.webp';

export default {
  slug: 'gym-swimming-pool',
  order: 7,
  title: '3D Render Gym & Pool',
  subtitle: 'Large-scale 3D renderings with pool and gym zones',
  tags: ['gymfloorplans', 'gymlayouts'],

  images: {
    hero: gymSwimmingPool,
    aboutTop: gymSwimmingPoolHow,
    aboutBottom: gymSwimmingPoolResult,
  },

  howText:
    'We created gym + swimming pool floor plans with 2D and 3D visualization. Zones are separated for safety and convenience. Layouts for gym + swimming pool and interior design for gym + swimming pool consider circulation, ergonomics, and materials.',

  resultText:
    'Clients receive ready plans for presentations, marketing, and investor pitches, simplifying promotion and project approvals.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
